import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDownIcon } from '../../../model/icons';

// Сворачиваемый блок карточки события (коэффициенты / счёт / ставки).
export default function BetAccordion({ label, children }) {
    const [open, setOpen] = useState(false);
    return (
        <div className={`bt-acc${open ? ' open' : ''}`}>
            <button type="button" className="bt-acc-head" onClick={() => setOpen(!open)}>
                {label}
                <ChevronDownIcon />
            </button>
            <div className="bt-acc-body">
                <div className="bt-acc-inner">
                    <div className="bt-acc-pad">{children}</div>
                </div>
            </div>
        </div>
    );
}

BetAccordion.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};
